import React, { useState } from 'react'
import Select from 'react-select'
import { InputLabel } from '@mui/material'

const SelectBox = ({
  label,
  value,
  defaultValue,
  onChange,
  data,
  valueKey,
  labelKey,
  onBlur,
  isDisabled,
  isMulti,
  options,
  flex,
  onMenuOpen,
  isLoading,
  error,
  position,
                     isClearable = true
}) => {
  const convertDataForSelect = (data = [], valueKey, labelKey) => {
    return data.map((item) => {
      return {
        ...item,
        value: item?.[valueKey],
        label: item?.[labelKey],
      }
    })
  }

  return (
    <div style={flex && { display: 'flex', gap: 20, alignItems: 'center' }}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        defaultValue={defaultValue}
        onBlur={onBlur}
        onMenuOpen={onMenuOpen}
        isMulti={isMulti}
        error={error}
        isLoading={isLoading}
        isClearable={false}
        isSearchable={true}
        options={options ?? convertDataForSelect(data, valueKey, labelKey)}
        styles={
          !error
            ? {
                option: (provided, state) => ({
                  ...provided,
                  color: 'black',
                  position: 'sticky',
                  cursor: 'pointer',
                  backgroundColor: state.isSelected ? 'rgba(25, 118, 210, 0.12)' : 'white',
                }),
                singleValue: (provided, state) => ({
                  ...provided,
                  color: 'black',
                  cursor: 'pointer',
                }),
                dropdownIndicator: (provided, state) => ({
                  ...provided,
                  padding: '7px',
                }),
                menu: (provided, state) => ({
                  ...provided,
                  position: position ?? 'absolute',
                  width: 'max-content',
                  minWidth: 200,
                }),
                control: (provided, state) => ({
                  ...provided,
                  border: state.isFocused ? '1px solid rgba(0, 0, 0, 0.23)' : '1px solid rgba(0, 0, 0, 0.23)',
                  borderColor: state.isFocused ? 'rgba(0, 0, 0, 0.23) !important' : 'rgba(0, 0, 0, 0.23) !important',
                  cursor: 'pointer',
                  minHeight: '35px',
                }),
                container: (provided) => ({
                  ...provided,
                  minWidth: 100,
                }),
                border: '1px solid rgba(0, 0, 0, 0.23)',
              }
            : {
                option: (provided, state) => ({
                  ...provided,
                  color: 'black',
                  cursor: 'pointer',
                  backgroundColor: state.isSelected ? 'rgba(25, 118, 210, 0.12)' : 'white',
                }),
                singleValue: (provided, state) => ({
                  ...provided,
                  color: 'black',
                  cursor: 'pointer',
                }),
                control: (provided) => ({
                  ...provided,
                  border: '1px solid #d32f2f',
                  cursor: 'pointer',
                }),
              }
        }
        isDisabled={isDisabled}
      />
    </div>
  )
}

export default SelectBox